export default __webpack_public_path__ + "assets/images/604d0b7d9f011085c8d128e1fe885899.png";